<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"><span class="t3">Copyright</span></p>
<p class="p3"><span class="t4">Publicado por</span></p>
<p class="p3"><span class="t4">Dreamspinner Press</span></p>
<p class="p5"><span class="t4">382 NE 191st Street #88329<br/>Miami, FL 33179–3899, USA</span></p>
<p class="p3"><a href="http://www.dreamspinnerpress.com/" target="_blank"><span class="t5">http://www.dreamspinnerpress.com/</span></a></p>
<p class="p6"><span class="t4">Este es un trabajo de ficción. Los personajes, nombres, lugares y sucesos son producto de la imaginación del autor o son usados de manera ficticia; cualquier semejanza con cualquier persona real, viva o muerta, establecimiento, negocio, o eventos reales son pura coincidencia. </span></p>
<p class="p3"><span class="t4">Amar significa… No avergonzarse.</span></p>
<p class="p3"><span class="t4">Copyright © 2009 de Andrew Grey</span></p>
<p class="p4"><span class="t4">Título original: Love means… No shame.</span></p>
<p class="p3"><span class="t4">Diseño de portada por Mara McKennen</span></p>
<p class="p3"><span class="t4">Traducido por: Saura García</span></p>
<p class="p4"><span class="t4">Se reservan todos los derechos. Queda prohibida la reproducción de cualquier parte de este libro, o su transmisión en cualquier formato o vía, ya sea electrónica o mecánica, incluyendo fotocopiado, grabado o almacenaje en cualquier soporte o sistema sin el expreso permiso de la Editorial, salvo cuando lo permita la ley. Para solicitar permiso y cualquier otra duda, por favor pónganse en contacto con Dreamspinner Press, 4760 Preston Road, Suite 244–149, Frisco, TX 75034</span></p>
<p class="p3"><a href="http://www.dreamspinnerpress.com/" target="_blank"><span class="t5">http://www.dreamspinnerpress.com/</span></a></p>
<p class="p7"><span class="t4">Impreso en los Estados Unidos de América.</span></p>
<p class="p3"><span class="t4">Primera Edición.</span></p>
<p class="p3"><span class="t4">Septiembre, 2009</span></p>
<p class="p4"><span class="t6">Edición eBook en Español</span><span class="t4">: 978–1–61372–824–6 </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?3c8d8de2